export const brandSchema = `
  id
  name
  email
  externalId        
`;
